import {Fragment, useState} from 'react';

import {Button} from 'primereact/button';

import {useCellEditing} from '../../../../shared/hooks/CellEditing';
import {ToastService} from '../../../../AppToast';

import {TenantInvoiceSettingMasterService} from '../TenantInvoiceSettingMasterService';

import DialogFormulas from './DialogFormulas';
import {useTranslation} from '../../../../shared/language';

export const Settings = (props) => {
  const {t} = useTranslation();

  const dataKey = 'id';

  const {items, setItems, invoiceGroups, allSettings, group, sortItems, tenantInvoiceSettingMasterId} = props;

  const [displayFormulas, setDisplayFormulas] = useState(0);
  const [selectedSetting, setSelectedSetting] = useState(null);
  const [formulaField, setFormulaField] = useState(null);
  const [formulasField, setFormulasField] = useState(null);

  const typeFormats = [
    {value: 'formatQuantity', label: t('common.quantity')},
    {value: 'formatPrice', label: t('common.unitPrice')},
    {value: 'formatTotal', label: t('common.total')},
    {value: 'formatTaxDetail', label: t('catalog.taxDetailDecimals')},
    {value: 'formatTaxAmount', label: t('common.totalTax')}
  ];
  const groupTypeCodes = [
    {value: '00', label: '00'},
    {value: '01', label: '01'},
    {value: '02', label: '02'},
    {value: '03', label: '03'},
    {value: '04', label: '04'},
    {value: '06', label: '06'}
  ];
  const groupXMLs = [
    {value: '01', label: t('common.fees')},
    {value: '02', label: t('common.otherInformation')},
    {value: '03', label: t('common.nonTaxableDeduction')},
    {value: '04', label: t('common.otherDeduction')},
    {value: '06', label: t('common.specialInvoice')},
  ];

  const showFormulas = (setting: any, formulaField: string, formulasField: string) => {
    setSelectedSetting(setting);
    setFormulaField(formulaField);
    setFormulasField(formulasField);
    setDisplayFormulas(Date.now);
  }
  const labelWidth = (window.innerWidth * 0.2) + 'px';

  const columns: any = [
    {field: 'lable', header: t('common.field'), editable: true, style: {minWidth: labelWidth, maxWidth: labelWidth}},
    {field: 'fieldName', header: t('common.variableName'), style: {minWidth: '200px', maxWidth: '200px'}},
    {field: 'orders', header: t('common.sequenceNumber'), dataType: 'number', editable: true, style: {minWidth: '90px', maxWidth: '90px'}},
    {field: 'lableWidth', header: t('common.labelWidth'), dataType: 'number', editable: true, style: {minWidth: '130px', maxWidth: '130px'}},
    {field: 'controlWidth', header: t('common.valueWidth'), dataType: 'number', editable: true, style: {minWidth: '140px', maxWidth: '140px'}},
    {field: 'maxLength', header: t('common.maxLength'), dataType: 'number', editable: true, style: {minWidth: '110px', maxWidth: '110px'}},
    {
      field: 'typeFormat', header: t('common.decimalPlaces'), dataType: 'dropdown', editable: true, inputProps: {options: typeFormats}, style: {minWidth: '120px', maxWidth: '120px'},
      checkEditable: (rowData) => {
        return rowData.dataType === 'int32';
      }
    },
    {field: 'use', header: t('catalog.emailUsage'), dataType: 'checkbox', editable: true, style: {minWidth: '80px', maxWidth: '80px'}, className: 'text-center'},
    {field: 'readOnly', header: t('common.editable'), dataType: 'checkbox', editable: true, style: {minWidth: '100px', maxWidth: '100px'}, className: 'text-center'},
    {
      field: 'formulaLabel', header: t('system.formula'), style: {minWidth: '150px'}, dataType: 'custom', customCell(rowData: any): any {
        if (rowData.useFormula) {
          if (rowData.formula) {
            return (<span className="text-primary pointer p-1" onClick={() => {
              showFormulas(rowData, 'formula', 'formulas')
            }}>{rowData.formula}</span>);
          } else {
            return (<span className="text-primary pointer p-1" onClick={() => {
              showFormulas(rowData, 'formula', 'formulas')
            }}>{t('system.addFormula')}</span>);
          }
        } else {
          return '';
        }
      }
    },
    {field: 'multipleFormula', header: t('common.multipleFormula'), dataType: 'checkbox', editable: true, style: {minWidth: '110px', maxWidth: '110px'}, className: 'text-center'},
    {field: 'groupTypeCode', header: t('common.group'), dataType: 'dropdown', editable: true, inputProps: {options: groupTypeCodes}, style: {minWidth: '90px', maxWidth: '90px'}},
    {field: 'required', header: t('common.requiredInput'), dataType: 'checkbox', editable: true, style: {minWidth: '110px', maxWidth: '110px'}, className: 'text-center'},
    {
      field: 'formulaLabel2', header: t('common.excelFormula'), style: {minWidth: '150px'}, dataType: 'custom', customCell(rowData: any): any {
        if (rowData.useFormula) {
          if (rowData.formulaExcel) {
            return (<span className="text-primary pointer p-1" onClick={() => {
              showFormulas(rowData, 'formulaExcel', 'formulasExcel')
            }}>{rowData.formulaExcel}</span>);
          } else {
            return (<span className="text-primary pointer p-1" onClick={() => {
              showFormulas(rowData, 'formulaExcel', 'formulasExcel')
            }}>{t('system.addFormula')}</span>);
          }
        } else {
          return '';
        }
      }
    },
    {field: 'lableExportExcel', header: t('common.excelColumnTitle'), editable: true, style: {minWidth: '120px', maxWidth: '120px'}},
    {field: 'ordersFormula', header: t('common.calculationOrder'), dataType: 'number', editable: true, style: {minWidth: '110px', maxWidth: '110px'}},
    {field: 'defaultValue', header: t('common.excelValue'), editable: true, style: {minWidth: '120px', maxWidth: '120px'}},
    {field: 'groupXML', header: t('common.xmlGroup'), dataType: 'dropdown', editable: true, inputProps: {options: groupXMLs, showClear: true}, style: {minWidth: '150px', maxWidth: '150px'}}
  ];

  switch (group) {
    case '00':
    case '01':
    case '02':
    case '03':
    case '04':
      columns[3].header = columns[3].header + ' (/12)';
      columns[4].header = columns[4].header + ' (/12)';
      break;
    case '05':
      columns[3].header = `${t('common.labelWidth')} (px)`;
      columns[4].invisible = true;
      break;
    case '06':
      columns[3].header = columns[3].header + ' (/100)';
      columns[4].header = columns[4].header + ' (/100)';
      break;
  }

  const {render: renderDataTable} = useCellEditing({
    dataKey,
    columns,
    items: items || [],
    onCellChange: (rowData, column, newValue) => {
      const _items = [...items];
      for (const _item of _items) {
        if (_item[dataKey] === rowData[dataKey]) {
          _item[column.field] = newValue;
        }
      }
      setItems(group, _items);
    }
  });

  const refreshItems = () => {
    sortItems(group);
  }

  const saveItems = () => {
    TenantInvoiceSettingMasterService.updateByGroup(tenantInvoiceSettingMasterId, group, items).then(() => {
      ToastService.success();
    });
  }

  const onFormulasSubmit = () => {
    setDisplayFormulas(0);
  }

  return (
    <Fragment>
      <div className="mb-1">
        <Button icon="pi pi-refresh" label={t('common.sort')} className="p-button-outlined mr-2" onClick={refreshItems}/>
        {tenantInvoiceSettingMasterId &&
					<Button icon="pi pi-save" label={t('common.save')} className="p-button-outlined p-button-success" onClick={saveItems}/>
        }
      </div>
      {renderDataTable()}
      {selectedSetting &&
          <DialogFormulas display={displayFormulas} setting={selectedSetting} formulaField={formulaField} formulasField={formulasField} invoiceGroups={invoiceGroups} allSettings={allSettings}
                          onSubmit={onFormulasSubmit}/>
      }
    </Fragment>
  );
}
